/**
 * created by lei lei
 * 快捷方式组件
 */
import React, {Component} from 'react';
import PropTypes from 'prop-types';
import checked from "../workRecord/img/checked.png";

export default class ShortcutItem extends Component {
    static defaultProps = {
        imgUrl:'',
        title:'标题',
        checked:false,
        itemWidth:250
    };
    static propTypes = {
        imgUrl:PropTypes.string,
        title:PropTypes.string.isRequired,
        checked:PropTypes.bool,
        itemClick:PropTypes.func,//点击每一项
    };

    constructor(props) {
        super(props);
        this.state = {}
    }

    componentWillMount() {
    }

    componentDidMount() {
    }

    render() {
        // border 选中 是为了解决占位后，下面空白
        return (
            <div style={{display: 'flex',position:"relative"}}>
                <div style={{width: this.props.itemWidth, background: 'white',border:this.props.checked?'1px solid #b292ee':'none',boxSizing:'border-box'}}>
                    <div onClick={() => {
                        this.props.itemClick&&this.props.itemClick();
                    }} style={{cursor: ' pointer', height: this.props.checked?158:160, position: 'relative'}}>
                        <div style={{paddingTop: 29}}>
                            <div style={{
                                textAlign: 'center',
                                height: 68,
                                lineHeight: '68px'
                            }}>
                                <img style={{width: 68, height: 68}} src={this.props.imgUrl}
                                     alt=""/>
                            </div>
                        </div>
                        <div style={{
                            textAlign: 'center',
                            fontSize: 16,
                            marginTop: 18
                        }}>{this.props.title}</div>
                    </div>
                    {
                        this.props.checked?<div style={{position: 'absolute', right: 0, bottom: 0, color: 'blue', cursor: 'pointer'}}
                                                onClick={() => {
                                                }}>
                            <img src={checked} style={{width: 30, height: 30}} alt=""/>
                        </div>:null
                    }

                </div>

            </div>
        )
    }

}